import React from 'react';
import { RichText } from 'prismic-reactjs';
import { GridWrapper, Container, Title, TextContainer } from './keyword-grid.styled'; // import { ItemsProps } from '@components/module/items-props.type';
var LargeList = function LargeList(_ref) {
    var items = _ref.items;
    return /*#__PURE__*/ React.createElement(GridWrapper, null, items.map(function (_ref2, id) {
        var keyword = _ref2.keyword, description = _ref2.description;
        var key = "" + keyword + id;
        return /*#__PURE__*/ React.createElement(Container, {
            key: key
        }, /*#__PURE__*/ React.createElement(Title, null, keyword), /*#__PURE__*/ React.createElement(TextContainer, null, /*#__PURE__*/ React.createElement(RichText, {
            render: description === null || description === void 0 ? void 0 : description.raw
        })));
    }));
};
export default LargeList;
